<template>
  <section class="blue-sec">
    <div
      class="container aos-init aos-animate"
      data-aos="fade-down"
      data-aos-duration="2000"
    >
      <h2>What does Renters Insurance cover?</h2>
      <p>
        Renters Insurance liability insurance covers the housing owner's
        property when it gets damaged/destroyed due to resident-caused fire,
        water damage*, smoke or explosion. The resident's personal belongings
        can be covered from fire, theft, explosion &amp; other covered
        incidents. Your policy will cover the cost to repair or replace property
        when the unexpected happens.
        <br />
        <small>
          *In North Carolina, water damage liability is optional for Renters
          Insurance.
        </small>
      </p>
    </div>
  </section>
  <BaseModal :name="modalLabel">
    <covered-modal />
  </BaseModal>
</template>

<script lang="ts" setup>
import BaseModal from "@/views/modals/BaseModal.vue";
import useModal from "@/hooks/useModal";
import Modals from "@/utils/Modals";
import CoveredModal from "@/views/modals/context/CoveredModal.vue";

const modalLabel = Modals.COVERED_MODAL.label;
const { toggleModal } = useModal();
const showAccidentalDamageModal = () => {
  toggleModal(Modals.COVERED_MODAL.label);
};
</script>
